import styled, { css } from 'styled-components';
import { ApModal, colors } from '@alixpartners/ui-components';

interface IDropdownProps {
  disabled?: boolean;
}

export const StyledModal = styled(ApModal)`
  .ap-modal-wrapper {
    overflow: hidden;
  }

  .ap-modal-content {
    max-width: 560px;
    max-height: 100%;
  }

  .ap-modal-header {
    border: none;
    padding: 8px 16px 16px 32px;

    h4 {
      font-weight: 500;
      font-size: 23px;
      line-height: 31px;
      letter-spacing: 0.3px;
      padding-top: 8px;
    }

    .ap-button-icon {
      align-self: flex-start;
    }
  }

  .ap-modal-body {
    padding: 16px 32px 32px;
    line-height: 24px;
    display: flex;
    flex-direction: column;
    overflow: unset;
  }

  .ap-modal-footer {
    padding: 8px 32px;
  }
`;

export const TextContent = styled.div`
  white-space: pre-line;
`;

export const ControlArea = styled.div`
  background-color: ${colors.green0};
  margin: 24px -32px -32px -32px;
  padding: 24px 32px 32px;
`;

export const DropdownWrapper = styled.div<IDropdownProps>`
  display: flex;
  flex-direction: column;
  padding-top: 24px;

  &:first-child {
    padding-top: 0;
  }

  .react-autosuggest__suggestions-container {
    &--open {
      max-height: 170px;
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      .ap-search-dropdown {
        cursor: not-allowed;
      }
      input {
        pointer-events: none;
      }
    `}
`;

export const Label = styled.div`
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
  color: ${colors.grey5};
  padding: 4px 0;
`;
